export const COUNTRIES_LIST = 'COUNTRIES_LIST'



// WEBPACK FOOTER //
// ./src/store/actions/countries.js